/**
 * UTM query 兜底：referrer 为空时，若 query 含 utm 参数仍可写入归因。
 */

/**
 * 判断 search 是否包含名称带 "utm" 的 query 参数。
 * referrer 为空时的兜底来源条件。
 */
export const hasUtmQueryParams = (search: string): boolean => {
  const raw = search.trim();
  if (!raw) {
    return false;
  }

  try {
    const query = raw.startsWith('?') ? raw.slice(1) : raw;
    const params = new URLSearchParams(query);
    for (const key of params.keys()) {
      if (key.toLowerCase().includes('utm')) {
        return true;
      }
    }
  } catch {
    return false;
  }

  return false;
};
